import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCinemographHero = styled.div`
  .loader-cinemograph {
    width: 100%;
    height: auto !important;
    margin-top: ${toRem(-52)};
    position: relative;

    &-tall {
      aspect-ratio: 2/3;

      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
        margin-top: ${toRem(-88)};
      }
    }

    &-short {
      aspect-ratio: 1/1;
      padding-top: 0 !important;

      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
        margin-top: ${toRem(-88)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        aspect-ratio: 5/2;
      }
    }

    &-image {
      width: 100%;
      margin-top: 0;
      aspect-ratio: 1/1;
      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 3/1;
      }
    }

    .cinemograph-loading-logo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      &::before {
        font-size: ${toRem(64)};
      }

      &.animate-logo {
        opacity: 0.05;
        transition: 2s;
        transition-delay: 1s;
      }
    }
  }

  .vjs-control-bar,
  .vjs-title-bar {
    display: none;
  }
  .cinemograph-image {
    width: 100%;
    aspect-ratio: 1/1;
    @media only ${baseVariables.mediaQuery.md} {
      aspect-ratio: 3/1;
    }
  }

  .cinemograph-tall {
    .video-js {
      width: 100%;
      aspect-ratio: 2/3;
      height: auto !important;
      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
      }
    }
  }

  .cinemograph-short {
    .video-js {
      width: 100%;
      aspect-ratio: 1/1;
      height: auto !important;
      padding-top: 0 !important;

      @media only ${baseVariables.mediaQuery.md} {
        aspect-ratio: 16/9;
      }

      @media ${baseVariables.mediaQuery.lg} {
        aspect-ratio: 5/2;
      }
    }
  }

  .dark-video-control {
    color: ${baseVariables.color['merch30']};
  }

  svg {
    position: absolute;
    top: ${toRem(80)};
    right: ${toRem(24)};
    @media ${baseVariables.mediaQuery['md']} {
      top: ${toRem(112)};
    }
    height: ${toRem(48)};
    width: ${toRem(48)};
  }

  .video-overlay {
    margin-top: ${toRem(-52)};
    @media ${baseVariables.mediaQuery.md} {
      margin-top: ${toRem(-88)};
    }
  }

  .video-container {
    padding: 0;
    position: relative;
    .video-js {
      height: 100vw;
      padding-top: 0;
      .vjs-tech {
        object-fit: cover;
      }
      .vjs-text-track-display {
        min-height: ${toRem(32)};
        position: absolute;
        bottom: ${toRem(8)};
        width: 100%;
        left: 0;
        right: 0;
        pointer-events: none;
      }
    }
    @media ${baseVariables.mediaQuery.md} {
      .video-js {
        height: 56.25vw;
        padding-top: 56.25%;
        .vjs-tech {
          object-fit: cover;
        }
      }
    }
  }

  .cinemograph--scrim-component {
    background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50%;
  }

  .icon-play-pause {
    position: absolute;
    top: ${toRem(52)};
    right: 0;

    @media ${baseVariables.mediaQuery.md} {
      top: ${toRem(112)};
      right: ${toRem(24)};
    }
    [dir='rtl'] & {
      left: 0;
      right: unset;
      @media ${baseVariables.mediaQuery.md} {
        left: ${toRem(24)};
      }
    }
    width: ${toRem(80)};
    height: ${toRem(80)};
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      opacity: 0.62;
      height: ${toRem(48)};
      width: ${toRem(48)};
      background: ${baseVariables.color['base10']};
      color: ${baseVariables.color['base20']};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        opacity: 1;
        transition: 0.5s;
      }
    }
  }
  .overlay_text {
    position: absolute;
    bottom: ${toRem(16)};
    right: ${toRem(24)};
    z-index: 2;
    background: ${baseVariables.color['merch30']};
    opacity: 0.54;
  }
`;
